import type { StateStorage } from 'zustand/middleware';
import { bridgeRequest } from './client';

// zustand `persist` 의 storage 어댑터 — native 환경에서 expo-secure-store(via bridge) 사용.
// 데스크톱 브라우저에서는 사용되지 않음 (auth-store가 isNative()로 분기).

export const bridgeSecureStorage: StateStorage = {
  async getItem(key) {
    try {
      const value = await bridgeRequest<string | null>(
        { type: 'secure.get', payload: { key } },
        { timeoutMs: 3000 },
      );
      return value ?? null;
    } catch (e) {
      console.warn('[bridge/secure.storage] getItem failed', key, e);
      return null;
    }
  },
  async setItem(key, value) {
    try {
      await bridgeRequest<void>(
        { type: 'secure.set', payload: { key, value } },
        { timeoutMs: 3000 },
      );
    } catch (e) {
      console.warn('[bridge/secure.storage] setItem failed', key, e);
    }
  },
  async removeItem(key) {
    try {
      await bridgeRequest<void>({ type: 'secure.delete', payload: { key } }, { timeoutMs: 3000 });
    } catch (e) {
      console.warn('[bridge/secure.storage] removeItem failed', key, e);
    }
  },
};
